import { useEffect, useState } from 'react';

/**
 * What a media query says right now, kept up to date. The same queries the
 * stylesheet branches on are asked here when the answer changes the markup
 * rather than only its presentation — a card and a table row are different
 * shapes, not the same shape laid out differently.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const listen = (): void => setMatches(media.matches);
    listen();
    media.addEventListener('change', listen);
    return () => media.removeEventListener('change', listen);
  }, [query]);

  return matches;
}
